
import { CheckCircle2 } from "lucide-react"
import { Button } from "@/components/ui/button"

// Account Step
export function SocialConnection({
    value,
    onChange,
    onNext,
}: {
    value: string
    onChange: (value: string) => void
    onNext: () => void
}) {

    const socialProviders = [
        {
            label: "Continue with Google",
            icon: "/google.svg",
            onClick: () => {
                onChange("Google")
                onNext()
            }
        },
        {
            label: "Continue with Apple",
            icon: "/apple.svg",
            onClick: () => {
                onChange("Apple")
                onNext()
            }
        },
        {
            label: "Continue with Email",
            icon: "/email.svg",
            onClick: () => {
                onChange("Email / Magic Link")
                onNext()
            }
        },
        {
            label: "Continue as Guest",
            icon: "/guest.svg",
            onClick: () => {
                onChange("Continue as Guest")
                onNext()
            }
        },
    ]
    return (
        <div className="flex flex-col space-y-3 mt-6">
            <Button
                variant="outline"
                className="flex items-center justify-center space-x-2"
                onClick={() => {
                    onChange("Google")
                    onNext()
                }}
            >
                <img src="/placeholder.svg?height=20&width=20" alt="Google" className="h-5 w-5" />
                <span>Continue with Google</span>
            </Button>

            <Button
                variant="outline"
                className="flex items-center justify-center space-x-2"
                onClick={() => {
                    onChange("Apple")
                    onNext()
                }}
            >
                <img src="/placeholder.svg?height=20&width=20" alt="Apple" className="h-5 w-5" />
                <span>Continue with Apple</span>
            </Button>

            <Button
                variant="outline"
                className="flex items-center justify-center space-x-2"
                onClick={() => {
                    onChange("Email / Magic Link")
                    onNext()
                }}
            >
                <span>Continue with Email</span>
            </Button>

            <div className="relative my-2">
                <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-[#f8f5f1] text-gray-500">or</span>
                </div>
            </div>

            <Button
                variant="secondary"
                className="flex items-center justify-center"
                onClick={() => {
                    onChange("Continue as Guest")
                    onNext()
                }}
            >
                Continue as Guest
            </Button>
        </div>
    )
}
